import React, { useRef } from "react";
import { useParams } from "react-router-dom";
import styles from "../../styles/SingleTranscript.module.scss";
import Transcript from "../../components/reusable/SingleTranscript/Transcript";
import { useEffect } from "react";
import { LocalStorageManager } from "../../services/LocalStorageManager";
import { useDispatch, useSelector } from "react-redux";
import { setDataset } from "../../redux/dataset/datasetSlice";
import { fetchTranscriptById } from "../../api/transcriptsApi";
import {
  setLocalTranscriptData,
  handleLocalStorageList,
} from "../../services/LocalStorageManager";
import TranscriptTitle from "../../components/reusable/SingleTranscript/TranscriptTitle";
import { setHeaderHeight } from "../../redux/header/headerSlice";
import ActionButtons from "../../components/reusable/SingleTranscript/ActionButtons";

export default function SingleTranscript() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const dataset = useSelector((state) => state.datasetSlice.dataset);

  function filterAndCopyDataset(dataset) {
    if (!dataset.transcript || !dataset.transcript.segments) {
      return dataset; // Return the original dataset if there are no segments
    }

    // Filter out segments without a speaker and text
    const filteredSegments = dataset.transcript.segments.filter(
      (segment) =>
        !(segment.speaker.trim() === "" && segment.text.trim() === "")
    );

    return {
      ...dataset,
      transcript: {
        ...dataset.transcript,
        segments: filteredSegments,
      },
    };
  }

  useEffect(() => {
    const modifiedDataset = filterAndCopyDataset(dataset);
    setLocalTranscriptData(modifiedDataset);
  }, [dataset]);

  // Fetch transcript data from the server
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetchTranscriptById(id);
        const localDataset = LocalStorageManager({ data: response });
        dispatch(setDataset(localDataset));
        handleLocalStorageList(localDataset);
      } catch (error) {
        console.log("Failed to fetch the transcript", error);
      }
      return;
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRef = useRef(null);

  useEffect(() => {
    function adjustStickyTop() {
      if (headerRef.current) {
        const headerHeight = headerRef.current.offsetHeight;
        dispatch(setHeaderHeight(headerHeight));
      }
    }

    adjustStickyTop();

    window.addEventListener("resize", adjustStickyTop);
    return () => {
      window.removeEventListener("resize", adjustStickyTop);
    };
  }, [dispatch, dataset.title]);

  return (
    <div className={styles.singleTranscriptWrapper}>
      <div className={styles.stickyHeader} ref={headerRef}>
        <TranscriptTitle
          title={dataset.title}
          editLocked={dataset.transcript_status === "COMPLETED"}
        />
        <ActionButtons dataset={dataset} />
      </div>
      <Transcript />
    </div>
  );
}
